import { getCurrentLocation } from './getPath';
export const getIsHelpDesk = () => {
  return getCurrentLocation().split('/')[1] === 'helpdesk';
};